import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'inbox-webchat-install-instructions-dialog',
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatDividerModule],
  templateUrl: './webchat-install-instructions-dialog.component.html',
})
export class WebchatInstallInstructionsDialogComponent {}
